import { hashHistory } from 'react-router'

export default hashHistory



// WEBPACK FOOTER //
// ../src/routes/history.js